import { callBedrockProxy, getBedrockErrorMessage } from '../../utils/bedrockClient';
import type { ChatMessage } from '../../utils/aiAgent';
function createPlannerMessage(prompt: string): ChatMessage {
  return {
    id: `nlq-planner-${Date.now()}`,
    role: 'user',
    content: prompt,
    timestamp: Date.now()
  };
}
function createExplanationMessage(prompt: string): ChatMessage {
  return {
    id: `nlq-explain-${Date.now()}`,
    role: 'user',
    content: prompt,
    timestamp: Date.now()
  };
}
export async function callPlanner(prompt: string, signal?: AbortSignal): Promise<string> {
  const msg = createPlannerMessage(prompt);
  try {
    const response = await callBedrockProxy([msg], signal);
    return response;
  } catch (err) {
    throw new Error(getBedrockErrorMessage(err));
  }
}
export async function callExplanation(prompt: string, signal?: AbortSignal): Promise<string> {
  const msg = createExplanationMessage(prompt);
  try {
    const response = await callBedrockProxy([msg], signal);
    return response;
  } catch (err) {
    throw new Error(getBedrockErrorMessage(err));
  }
}
export function parseQueryDSL(raw: string): Record<string, unknown> | null {
  let cleaned = raw.trim();
  const jsonMatch = cleaned.match(/```(?:json)?\s*([\s\S]*?)```/);
  if (jsonMatch) {
    cleaned = jsonMatch[1].trim();
  }
  try {
    const parsed = JSON.parse(cleaned);
    if (typeof parsed === 'object' && parsed !== null) {
      return parsed;
    }
    return null;
  } catch {
    return null;
  }
}